import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    bottomNavigation: {
        backgroundColor: '#efefef',
        bottom: 0,
        position: 'fixed',
        width: '100%',
    }
}))
